import { useEffect, useState } from "react";
import BasicWrapper from "../../components/basicWrapper/basicWrapper";
import ExtendedWrapper from "../../components/extendedWrapper/extendedWrapper";
import { IvnoiceContextProvider } from "../createInvoice/createInvoiceContext";

import "../createInvoice/steps/createInvoice.css"
//
import CreateTemplateWrapperExtended from "./createTemplateWrapperExtended";
import StepsHeader from "./steps/utils/stepsHeader";

export default function CreateTemplateWrapper() {
    const [invoiceStep, setInvoiceStep] = useState(0);
    const [maxStep, setMaxStep] = useState(1);
    const [skip, setSkip] = useState(false);

    // Update max step by 1 when reaching current max step
    useEffect(() => {
        if (maxStep === 6) return;
        if (invoiceStep >= maxStep) setMaxStep(maxStep + 1);
    }, [invoiceStep]);

    return (
        <>
        <StepsHeader skip={skip} step={invoiceStep} setInvoiceStep={setInvoiceStep} maxStep={maxStep} />
        <BasicWrapper>
            <IvnoiceContextProvider>
                <CreateTemplateWrapperExtended
                    invoiceStep={invoiceStep} setInvoiceStep={setInvoiceStep}
                    maxStep={maxStep} setSkip={setSkip}/>
            </IvnoiceContextProvider>
        </BasicWrapper>
        </>
    )
}